import { render, staticRenderFns } from "./ProblemSubmitUpload.vue?vue&type=template&id=eb1038da&scoped=true&"
import script from "./ProblemSubmitUpload.vue?vue&type=script&lang=js&"
export * from "./ProblemSubmitUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1038da",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BFormFile, BOverlay, BRow} from 'bootstrap-vue'
    installComponents(component, {BCol, BFormFile, BOverlay, BRow})
    

export default component.exports